import { render } from "./CGridLayoutRow.vue?vue&type=template&id=53739887&scoped=true"
import script from "./CGridLayoutRow.vue?vue&type=script&lang=js"
export * from "./CGridLayoutRow.vue?vue&type=script&lang=js"

import "./CGridLayoutRow.vue?vue&type=style&index=0&id=53739887&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53739887"]])

export default __exports__